import React from 'react'
import classnames from 'classnames'
import WithLabel from '../WithLabel'
import RawDatetimeInput from '../RawDatetimeInput'
import styles from './LabeledDatetimeInput.scss'

/**
 * A date input with a time input
 */
const LabeledDatetimeInput = props => {
  return (
    <WithLabel {...props}>
      {({ active, disabled, error, ...props }) => (
        <RawDatetimeInput
          disabled={disabled}
          className={classnames(styles.input, {
            [styles.active]: active,
            [styles.disabled]: disabled,
            [styles.error]: error,
          })}
          {...props}
        />
      )}
    </WithLabel>
  )
}

export default LabeledDatetimeInput
